/* istanbul ignore file */

import type {
  BaseFieldObject,
  NullEcommerceEvent,
  PlacementProductListFieldObject,
} from '@noths/polaris-dev-ts-types';

import type { ProductEventWithEcommerce } from 'src/types/googleAnalytics';

export enum Placement {
  ActiveProducts = 'item_page.rr_new_1',
  SameSeller2 = 'item_page.same_seller2',
  SimilarProducts = 'item_page.entrypoint',
  SimilarProductsSaleBury = 'item_page.similar_products_sale_bury',
}

export type ProductImpressionsInitialEvent = NullEcommerceEvent;

export interface ProductImpressionsEcommerce {
  ecommerce: {
    impressions: BaseFieldObject[];
  };
}

export type ProductShelfImpressionEvent = ProductEventWithEcommerce<
  'product_impressions',
  'Product Impressions',
  string,
  ProductImpressionsEcommerce
>;

type EventCategory = 'Listings Recommendations';

export type ProductClickEvent = {
  ecommerce: {
    click: {
      actionField: {
        list: PlacementProductListFieldObject['list'];
      };
      products: BaseFieldObject[];
    };
  };
  event: 'product_clicks';
  event_action: 'Product Click';
  event_category: EventCategory;
  event_label: string;
};

export interface ProductShelfNavigationImpression {
  event: 'custom_event';
  event_action: 'Arrow click next' | 'Arrow click previous' | 'Swipe next' | 'Swipe previous';
  event_category: EventCategory;
  event_label: string;
}
